import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, tap } from "rxjs";
import { constants } from "src/app/config/constant";
import { ApiHttpService } from "./apihttp.service";

@Injectable({
    providedIn: 'root'
})

export class InterceptorService implements HttpInterceptor {
    constructor(private http: ApiHttpService, public config: constants) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let suncash_key = this.config.SUNCASH_KEY;
        let token = localStorage.getItem("accessToken") ? (localStorage.getItem("accessToken")) : '';
        if (token) {
            req = req.clone({ headers: req.headers.set('Authorization', `Bearer ${token}`) });
            req = req.clone({ headers: req.headers.set('Content-Type', 'application/x-www-form-urlencoded') });
            req = req.clone({ headers: req.headers.set('x-suncash-apikey', suncash_key) });
        } else {
            req = req.clone({ headers: req.headers.set('Content-Type', 'application/x-www-form-urlencoded') });
            req = req.clone({ headers: req.headers.set('x-suncash-apikey', suncash_key) });
        }

        if (this.http.showLoader)
            this.http.loader(true);
        else
            this.http.showLoader = true;

        return next.handle(req).pipe(
            tap((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    this.http.loader(false);
                }
            }, (err: any) => {
                this.http.loader(false);
                if (err instanceof HttpErrorResponse) {
                    if (err.error.statusCode == 400) {

                    } else if (err.error.statusCode == 401) {


                    } else if (err.error.statusCode == 402) {


                    } else if (err.error.statusCode == 403) {


                    } else {

                    }
                }
            }));
    }
}
